import {defineStore} from 'pinia';
import {ModuleAssetCategory} from '../moduleConst';
import {BaseDictionaryStore} from '../baseDictionaryStore';
import assetCategoryAPI from '@/apis/di/assetCategoryAPI';
const assetCategoryStore = new BaseDictionaryStore(assetCategoryAPI);
export const useAssetCategoryStore = defineStore(ModuleAssetCategory, {
  state: () => ({
    ...assetCategoryStore.state,
    _config: {
      key: 'asset_category_id',
      code: 'asset_category_alias',
      name: 'asset_category_name',
      table: 'di_asset_category',
      quickFollow: 'active',
      moduleName: 'Loại tài sản/tang vật',
      defaultSort: 'asset_category_alias'
    },
    moduleName: 'asset_category',
  }),
  actions: {...assetCategoryStore.action},
  getters: {
    ...assetCategoryStore.getters,
  },
});
